module.exports = __webpack_public_path__ + "static/media/IMG_8893.fdc638a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/vertical/IMG_8893.jpg
// module id = 166
// module chunks = 0